import * as tslib_1 from "tslib";
import { ANCHOR_TAG_NAME, IMG_TAG_NAME } from './constants';
import processAnchorElements, { AnchorElementsSource } from './processAnchorElements';
import { OWA_REFERENCE_ATTACHMENTS_ID } from './shouldProcessLink';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { trace } from 'owa-trace';
export default function processContentChangedFromSetContent(event, linkPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var contentChangedEvent, allLinks, hiddenReferenceAttachments, images;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove')) {
                        return [2 /*return*/];
                    }
                    trace.info('processContentChangedFromSetContent');
                    contentChangedEvent = event;
                    if (contentChangedEvent.source !== "SetContent" /* SetContent */) {
                        return [2 /*return*/];
                    }
                    allLinks = linkPlugin.editor.queryContent(ANCHOR_TAG_NAME);
                    hiddenReferenceAttachments = linkPlugin.editor.queryContent('#' + OWA_REFERENCE_ATTACHMENTS_ID);
                    images = linkPlugin.editor.queryContent(IMG_TAG_NAME);
                    return [4 /*yield*/, processAnchorElements(allLinks, hiddenReferenceAttachments, AnchorElementsSource.ContentChangedFromSetContent, linkPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds, images.length)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=processContentChangedFromSetContent.js.map